import styled from '@emotion/styled';

export const AppFrame = styled.div`
  min-height: 100dvh;
  color: #151515;
  background:
    radial-gradient(circle at top left, rgba(57, 58, 251, 0.12), transparent 34rem),
    linear-gradient(180deg, #f7f8ef 0%, #ffffff 42%, #f3f6ff 100%);
`;

export const TopBar = styled.header`
  position: sticky;
  top: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: calc(12px + env(safe-area-inset-top)) 18px 12px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(18px);
`;

export const BrandBlock = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
`;

export const BrandMark = styled.div`
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 16px;
  color: #ffffff;
  font-weight: 800;
  letter-spacing: -0.04em;
  background: linear-gradient(145deg, #393afb, #11138f);
  box-shadow: 0 14px 30px rgba(57, 58, 251, 0.24);
`;

export const Eyebrow = styled.div`
  color: #687076;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.11em;
  line-height: 1.1;
  text-transform: uppercase;
`;

export const Title = styled.div`
  overflow: hidden;
  margin-top: 2px;
  font-size: clamp(21px, 6vw, 30px);
  font-weight: 850;
  letter-spacing: -0.04em;
  line-height: 1.05;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ProfileButton = styled.button`
  display: grid;
  width: 44px;
  height: 44px;
  flex: 0 0 auto;
  place-items: center;
  border: 0;
  border-radius: 999px;
  color: #ffffff;
  font-weight: 800;
  background: #171717;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.18);
`;

export const NetworkBanner = styled.div`
  position: sticky;
  top: calc(69px + env(safe-area-inset-top));
  z-index: 35;
  margin: 10px 14px 0;
  padding: 10px 14px;
  border: 1px solid rgba(180, 83, 9, 0.28);
  border-radius: 16px;
  color: #7c2d12;
  font-size: 14px;
  font-weight: 800;
  background: #fff7ed;
`;

export const InstallCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 14px auto 0;
  width: min(92vw, 780px);
  padding: 14px;
  border: 1px solid rgba(57, 58, 251, 0.14);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);

  strong,
  span {
    display: block;
  }

  span {
    color: #687076;
    font-size: 13px;
  }
`;

export const Content = styled.main`
  min-height: calc(100dvh - 80px);
  padding: 0 0 calc(96px + env(safe-area-inset-bottom));
`;

export const BottomNav = styled.nav`
  position: fixed;
  right: max(12px, env(safe-area-inset-right));
  bottom: max(12px, env(safe-area-inset-bottom));
  left: max(12px, env(safe-area-inset-left));
  z-index: 50;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  max-width: 520px;
  margin: 0 auto;
  padding: 8px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);
  backdrop-filter: blur(18px);

  a,
  button {
    display: flex;
    min-height: 54px;
    align-items: center;
    justify-content: center;
    gap: 7px;
    border: 0;
    border-radius: 18px;
    color: #5b616e;
    font: inherit;
    font-size: 13px;
    font-weight: 850;
    text-decoration: none;
    background: transparent;
    touch-action: manipulation;
  }

  @media (max-width: 420px) {
    gap: 4px;
    padding: 6px;

    a,
    button {
      min-height: 50px;
      gap: 4px;
      font-size: 11px;
    }
  }

  a.active {
    color: #ffffff;
    background: linear-gradient(145deg, #393afb, #2224c8);
    box-shadow: 0 12px 22px rgba(57, 58, 251, 0.22);
  }
`;

export const MenuProfile = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 4px 0 18px;
`;

export const ProfileLarge = styled.div`
  display: grid;
  width: 54px;
  height: 54px;
  place-items: center;
  border-radius: 18px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 850;
  background: #171717;
`;

export const MenuActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
